import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/Census/discharged`;

/**
 * Obtiene el listado de pacientes dados de alta (Discharged) con follow-up en curso.
 *
 * El scope por rol lo aplica el backend (Admin ve todos los locations,
 * otros roles solo su location primario). No se debe filtrar por location
 * del empleado desde el front.
 *
 * @param {Object} [filters]
 * @param {string} [filters.cipId]           - CIP específico.
 * @param {number} [filters.locationId]      - Filtrar por center (dentro del scope permitido).
 * @param {string} [filters.searchName]      - Búsqueda LIKE sobre el nombre completo.
 * @param {string} [filters.dateOfBirth]     - DOB exacto (YYYY-MM-DD).
 * @param {number} [filters.minLace]         - LACE+ mínimo (score ≥ valor).
 * @param {boolean} [filters.onlyOverdue]    - true = solo vencidos.
 * @param {number} [filters.followUpStatusId] - 42=Pending, 44=Completed (excluidos siempre), 45/46=Cancelled.
 * @param {string} [filters.dateFrom]        - Discharge date ≥ (YYYY-MM-DD).
 * @param {string} [filters.dateTo]          - Discharge date ≤ (YYYY-MM-DD).
 *
 * Ejemplo de llamada:
 * GET /api/Census/discharged?onlyOverdue=true&minLace=15
 *
 * Respuesta exitosa (200):
 * [
 *   {
 *     "dischargedEventId": 13,
 *     "cipId": "45000457653",
 *     "fullName": "COOPER, ELIZABETH",
 *     "dateOfBirth": "1983-08-08T00:00:00",
 *     "gender": "F",
 *     "phoneNumber": "(508) 933-6602",
 *     "mobileNumber": null,
 *     "memberEmail": "WHATABOUTLIZ808@GMAIL.COM",
 *     "admitDate": "2026-03-22T00:00:00",
 *     "dischargeDate": "2026-03-24T00:00:00",
 *     "facilityName": "HCA - LAWNWOOD REGIONAL MEDICAL CENTER AND PAVILION",
 *     "dischargeDisposition": null,
 *     "diagnoses": "L01.00 | F11.10 | B19.20 | L03.211",
 *     "laceScore": 20,
 *     "behavioralHealth": false,
 *     "attendingPhysicianName": "Kattan Villegas,Juan N",
 *     "lastSeen": "2026-04-23T00:00:00",
 *     "followUpId": 37,
 *     "followUpStatusId": 42,
 *     "followUpStatusName": "Pending",
 *     "dueDate": "2026-04-01T00:00:00",
 *     "completedDate": null,
 *     "hasClinicalNote": false,
 *     "followUpNotes": null,
 *     "employeeAssignedId": null,
 *     "lastContactDate": null,
 *     "callCount": 0,
 *     "isOverdue": true,
 *     "locationId": 8,
 *     "medicalCenter": "Port Saint Lucie",
 *     "locationAddress": "8980 S US HIGHWAY 1 STE 101 STE 101, Port St Lucie, FL - 34952-3482, Saint Lucie"
 *   }
 * ]
 *
 * Posibles errores:
 * 401 Sin token o token inválido.
 * 500 Excepción en el SP o pipeline (el repo retorna lista vacía para no romper el front).
 */
export const getDischargedPatients = async (filters = {}) => {
  try {
    const params = buildParams(filters);
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching discharged patients:", error);
    throw error;
  }
};

// Descarta valores vacíos para que axios no los envíe como query params.
const buildParams = (filters) => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    params[key] = value;
  });
  return params;
};
